import MaizeImage from 'assets/images/commodities/maize.jpg';
import CocoaImage from 'assets/images/commodities/cocoa.png';
import SoybeansImage from 'assets/images/commodities/soybeans.jpg';
import GingerImage from 'assets/images/commodities/ginger.jpg';
import SorghumImage from 'assets/images/commodities/sorghum.jpg';
import PaddyRiceImage from 'assets/images/commodities/paddy-rice.jpg';

export default [
  {
    name: 'Maize',
    image: MaizeImage,
    description: `
      Maize is one of the most utilized and multifunctional 
      crops in Africa. It is a major staple food grain not only 
      in Africa, but in many parts of the world like Latin America 
      and Asia and is also used as a major feed in developed countries. 
      The maize grain has numerous products ranging from edible grains 
      to syrups and oils. Some of its products are used for corn 
      ethanol and animal feed.
    `,
  },
  {
    name: 'Cocoa',
    image: CocoaImage,
    description: `
      Cocoa is the dried and fully fermented seed of Theobroma Cacao, 
      which can be put to many uses like the derivation of cocoa 
      solids and extraction of cocoa butter. It is a high income, 
      foreign exchange commodity that is required to pass certain 
      quality parameter tests to ensure that it is export ready.
    `,
  },
  {
    name: 'Soyabeans',
    image: SoybeansImage,
    description: `
      Soybean is a legume specie widely grown for feed and food. 
      Approximately 85% of the world’s soybean crop is processed 
      into soybean meal or soybean oil as well as human wholesome food. 
      In Nigeria, soybean grows majorly in the middle belt accounting 
      for 65 – 75% of total production. The legume is also a valuable 
      export commodity.
    `,
  },
  {
    name: 'Paddy rice',
    image: PaddyRiceImage,
    description: `
      Rice is an increasingly important crop in Nigeria and a major 
      staple in many parts of the world. It is a relatively easy 
      crop to produce and is grown mainly for sale to processors. 
      Different varieties of rice are grown in Nigeria, with 
      some being considered traditional varieties and other 
      foreign varieties being introduced over the years. 
      Rice is grown in paddies or on upland fields depending 
      on the requirements of the variety in question.
    `,
  },
  {
    name: 'Sorghum',
    image: SorghumImage,
    description: `
      Sorghum is the world’s fifth most important cereal crop. 
      It is typically produced on an annual basis, but some 
      varieties are perennial. It grows in clumps that may reach 
      over four meters high and it can be used for a variety of 
      purposes, including but not limited to the production of 
      alcoholic beverages, ethanol fuels (biofuels), flatbreads 
      and a number of other snacks. 
    `,
  },
  {
    name: 'Ginger',
    image: GingerImage,
    description: `
      Ginger is cultivated from its rhizomes and is a flowering 
      plant that has its rhizome, ginger root or ginger, used 
      as a spice or folk medicine. It is a herbaceous perennial 
      which grows annual pseudo stems. Being a high income, 
      foreign exchange commodity, ginger is required to pass 
      certain quality parameter tests to ensure that it is export ready..
    `,
  },
];
